export default {
  schemeId: 'Excellent-Scheme-Tool',
  orderId: 'Order-Query-Tool',
};
